import { render, staticRenderFns } from "./Debtor.vue?vue&type=template&id=e033a848&scoped=true&"
import script from "./Debtor.vue?vue&type=script&lang=js&"
export * from "./Debtor.vue?vue&type=script&lang=js&"
import style0 from "./Debtor.vue?vue&type=style&index=0&id=e033a848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e033a848",
  null
  
)

export default component.exports